import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiPost, ApiError } from "../api/client";

interface ChangeSecurityAPayload {
  current_password: string;
  new_security_answer: string;
}

interface ChangeResponse {
  ok: boolean;
  code: string;
}

export function useChangeSecurityA() {
  const qc = useQueryClient();
  return useMutation<ChangeResponse, ApiError, ChangeSecurityAPayload>({
    mutationFn: (p) => apiPost<ChangeResponse>("/api/auth/pm/change-security-a", p),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["pm-session"] }),
  });
}
